// removed by extract-text-webpack-plugin
module.exports = {"popwrap":"rate-RateUpdate-popwrap","header":"rate-RateUpdate-header","container":"rate-RateUpdate-container","centerTxt":"rate-RateUpdate-centerTxt","footer":"rate-RateUpdate-footer","btnWrap":"rate-RateUpdate-btnWrap","liPadding":"rate-RateUpdate-liPadding"};


//////////////////
// WEBPACK FOOTER
// ./src/components/rate/RateUpdate/index.css
// module id = 1825
// module chunks = 0